export default {
  menu: {
    overview: '概览',
    products: '产品',
    server: '云服务器',
    //lightServer:'轻量服务器',
    baremetal: '裸金属',
    mysql: '数据库',
    elb: '负载均衡',
    ssl: 'SSL证书',
    ip: '高防IP',
    account: '客户资料',
    billing: '账单',
    profile: "我的资料",
    help: '帮助',
    whiteList:'白名单',
    ddoscdn:'高防CDN',
    workOrder:'工单'
  }

}



// WEBPACK FOOTER //
// ./src/lang/zh-CN/menu.js